
import { applePayValidationRequest,  applePayPaymentRequest } from  './ApplePayRestClient';
import { merchantDisplay, APPLE_PAY_VERSION_NUMBER, merchantIdentifier } from './PaymentConf';
import {  PaymentStatus } from './PaymentStatus';

var session_id = "";

const existsApplePayJsApi = () =>  {
    return new Promise((resolve, reject) => {
        try {
            const enabled = window.ApplePaySession && window.ApplePaySession.canMakePayments();
            resolve(enabled);
        }
        catch (err) {
            reject(err);
        }
    })
}

export const isApplePayJsAvailable = () => {
    return existsApplePayJsApi()
        .then(() => {
            if (window.ApplePaySession && typeof window.ApplePaySession.canMakePaymentsWithActiveCard === 'function') {
                return window.ApplePaySession.canMakePaymentsWithActiveCard(merchantIdentifier);
            } else {
                return false;
            }
        })
        .catch(() => {
            return false;
        });
};

const getPaymentRequest = (countryCode, currencyCode, label, amount) => {
    return {
        currencyCode: currencyCode.trim(),
        countryCode: countryCode,
        requiredShippingContactFields: ['name', 'email', 'phone'],
        requiredBillingContactFields: ["postalAddress","email", "name","phone"],
        //lineItems: items,
        total: {
            label: label,
            amount: amount.toString()
        },
        supportedNetworks: [ 'visa', 'amex', 'masterCard' ],
        merchantCapabilities: ["supports3DS", "supportsCredit", "supportsDebit"],
    };
};

const getOnValidateMerchant = (resolve, reject, session, product) => {

    return (event) => {
        applePayValidationRequest(event.validationURL, product)
        .then((response) => {
            window.session_id = response.session_id;
            const responseObject = JSON.parse(response.apple_pay_session_object);
            session.completeMerchantValidation(responseObject);
        })
        .catch((err) => {
            session.abort();
        });   
    }
}

const getOnPaymentAuthorized = (resolve, reject, session,  product, quantity, paymentMethodId, category) => {
    return (event) => {
        applePayPaymentRequest(
            event.payment.token.paymentData,
            quantity,
            product,
            paymentMethodId,
            category,
            event.payment.billingContact,
            event.payment.shippingContact
            )
            .then((response) => {
                if (response.response === "1" && response.id) {
                    session.completePayment({status: window.ApplePaySession.STATUS_SUCCESS});
                    resolve(PaymentStatus.SUCCESS);
                    window.location = "/result/"+response.id;
                } else {
                    session.completePayment({status: window.ApplePaySession.STATUS_FAILURE});
                    reject();
                    if (response.id) {
                        window.location = "/result/"+response.id;
                    }
                    window.location = "/error/apple_payment_error";
                }
            })
            .catch((err) => {
                session.completePayment({status: window.ApplePaySession.STATUS_FAILURE});
                reject(err);
                window.location = "/error/apple_payment_error";
            });
    };
};

const getOnCancel = (resolve, reject, session) => {
    return (event) => {
        resolve(PaymentStatus.CANCEL);
    };
};

export const performApplePayPayment = (product, quantity, paymentMethodId, category) => {
    return new Promise((resolve, reject) => {
        const totalAmount = product.price * quantity;
        const paymentRequest = getPaymentRequest(product.countryCode ,product.currencySymbol, product.name, totalAmount.toFixed(2));
        try {
            const session = new window.ApplePaySession(APPLE_PAY_VERSION_NUMBER, paymentRequest);
            session.onvalidatemerchant = getOnValidateMerchant(resolve, reject, session, product);
            session.onpaymentauthorized = getOnPaymentAuthorized(resolve, reject, session, product, quantity, paymentMethodId, category
            );
            session.oncancel = getOnCancel(resolve, reject, session);
            session.begin();
        }
        catch (error) {}
    });
};


// WEBPACK FOOTER //
// ./client/components/ApplePayJsHandler.js